import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';

const container = document.getElementById('root');

// The pre-rendered SEO snapshot inside #root is for crawlers only and doesn't
// match the React tree, so never hydrate it — createRoot discards it on mount.
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
}
